import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';

export const getCaptchaLang = (siteLanguage: string | undefined) => {
  switch (siteLanguage) {
    case 'dk':
      return 'da';
    case 'de':
      return 'de';
    case 'uk':
      return 'en';
    case 'fr':
      return 'fr';
    case 'frbe':
      return 'fr';
    case 'nlbe':
      return 'nl';
    case 'nl':
      return 'nl';
    case 'no':
      return 'no';
    case 'fi':
      return 'fi';
    case 'se':
      return 'sv';
    default:
      return 'en';
  }
};

interface ReCaptchaProps {
  onChange: (token: string | null) => void;
  siteKey?: string;
}

export const ReCaptcha: React.FC<ReCaptchaProps> = ({ onChange, siteKey }) => {
  const { i18n } = useTranslation();
  if (!siteKey) {
    return null;
  }

  return (
    <ReCAPTCHA
      hl={getCaptchaLang(i18n.language)}
      sitekey={siteKey}
      onChange={onChange}
      key={getCaptchaLang(i18n.language)}
    />
  );
};
